import { React, useLayoutEffect } from "react";
import { PageHeader } from "../components/PageHeader";
import LegsForDays from "../assets/gallery/LegsForDays.jpeg";
import Alluring from "../assets/gallery/Alluring.jpeg";
import leatherBootsAndCrop from "../assets/gallery/bootsAndCrop.JPEG";

import {
  SessionPageContainer,
  InPersonSessionImage,
  IntroArea,
  IntroTextContainer,
  SessionImageContainer,
  ContentArea,
  SubTitle,
  SectionHeading,
  AccentBar,
  BiggerText,
  TertiaryTitle,
} from "../components/SessionPageComponents";
import { SessionTimingSection } from "../components/SessionTimingSection";
import { SessionTributeSection } from "../components/SessionTributeSection";
import { ContactSubTitle } from "../sections/ContactSection";
import { PrimaryButton } from "../components/Buttons";

import { Link } from "react-router-dom/cjs/react-router-dom.min";

export const InPersonSession = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SessionPageContainer>
      <ContentArea>
        <PageHeader title="Sessions" subtitle="Amsterdam" />

        <br />
        <IntroArea>
          <SessionImageContainer>
            <InPersonSessionImage image={LegsForDays} />
          </SessionImageContainer>
          <IntroTextContainer>
            Power Dynamics is my specialty, and 'special spot' when it comes to
            FemDom. I love to create a slow-motion, hypnotic vibe through
            seduction and and sensuality and gradually amp up intensity. I'm a
            passionate about building the fricction between desire & denial,
            tension & laughter, agony & ecstasy... With precision, care, and a
            lot of kinky lust, I seduce my preys into submission. And once I win
            you over, I will use you like the little play tool I made you to be.
            Getting your total surrender is just the beginning for Me - and the
            end of you.
            <br />
            Here are some examples of techniques I use to achieve that:
            <ul>
              <li>Clear expectations and safewords</li>
              <li>Power Play and Total Power Exchange</li>
              <li>Gorgeous outfits in leather, latex and high heels</li>
              <li>Bondage, specially using rope</li>
              <li>A mix of soft touches with hard core spanking</li>
              <li>Dirty talk, humiliation and mindfucks</li>
              <li>Pure, primal, unfiltered Sadism</li>
              <li>A touch of Female Supremacy</li>
              <li>Worship, devotion and surrender to Me</li>
              <li>Play with My glorious, gorgeous, sensitive Feet</li>
              <li>
                <Link
                  to="/sessions/list-of-practices"
                  style={{ textDecoration: "underline" }}
                >
                  Check here a more detailed list of practices I enjoy
                </Link>
              </li>
            </ul>
          </IntroTextContainer>
        </IntroArea>

        <br />
        <br />
        <SectionHeading style={{ textAlign: "center" }}>In My Presence...</SectionHeading>
        <AccentBar />

        <IntroArea invertOrderOnMobile>
          <IntroTextContainer>
            <TertiaryTitle>...I am your ruler and punisher...</TertiaryTitle>
            <BiggerText>
              My arts are about power - not sexual release. Flesh is secondary
              to surrender. Your desire is My weapon, not My goal.
            </BiggerText>
            <BiggerText>
              This is not a transaction. It's a sinful dance - a ceremony of
              pain and pleasure. An exchange of power and submission.
            </BiggerText>
            <BiggerText>
              Sobriety, preparation, respect and grooming are non-negotiable.
            </BiggerText>

            <BiggerText>
              Same-day pleas for My audience will be ignored — courtship,
              anticipation and preparation are part of the experience.
            </BiggerText>
            <BiggerText>
              Should your conduct repeatedly displease Me, the rite ends. If I'm
              not enjoying myself there is no point continuing.
            </BiggerText>
          </IntroTextContainer>
          <SessionImageContainer>
            <InPersonSessionImage image={Alluring} />
          </SessionImageContainer>
        </IntroArea>
        <br />
        <br />

        <div>
          <IntroArea>
            <SessionImageContainer>
              <InPersonSessionImage image={leatherBootsAndCrop} />
            </SessionImageContainer>

            <IntroTextContainer>
              <TertiaryTitle>... I am your guardian and owner.</TertiaryTitle>
              <BiggerText>
                Consent is sacred. A safeword is your sole right.
              </BiggerText>
              <BiggerText>
                This is not about you using Me to fullfil your fantasies. This
                is about Me - using you - to fullfil mine. And you love this.
              </BiggerText>
              <BiggerText>
                The soundscape of My ritual is silence cut with breath, moans,
                the crack of impact, and sometimes my signature evil laugh. I do
                not take Myself too seriously. But you will. Deadly serious.
              </BiggerText>

              <BiggerText>
                I favour loyalty over one-off indulgence. But for the rare,
                exceptional, brave ones, exceptions are made.
              </BiggerText>
              <BiggerText>
                And when our rite concludes, you will not be discarded. I return
                you back to the world softened, grounded, transformed.
              </BiggerText>
              <BiggerText>
                We seal the promise of future encounters with a hug, sore
                muscles, bruised skin and a silent smile - an echo of My touch.
              </BiggerText>
            </IntroTextContainer>
          </IntroArea>
        </div>

        <SessionTimingSection />

        <SessionTributeSection />

        <br />
        <SubTitle>Do you Dare to Surrender?</SubTitle>
        <br />

        <ContactSubTitle style={{ textAlign: "center" }}>
          <a href="https://blocksurvey.io/the-submission-amsterdam-71v0jGRiSEGFXl3abOxRVA?v=o">
            <PrimaryButton>I do, Mistress.</PrimaryButton>
          </a>
          <br />
          <br />
          <br />
          <br />
          <br />
        </ContactSubTitle>
      </ContentArea>
    </SessionPageContainer>
  );
};
